export type OnboardingUser = {
  selected_project?: string | null;
  selected_environment?: string | null;
  is_invited?: boolean | null;
};

export function onboardingLanding(user: OnboardingUser | null | undefined): string | null {
  const hasProject = Boolean(user?.selected_project?.trim());
  const hasEnvironment = Boolean(user?.selected_environment?.trim());
  if (hasProject && hasEnvironment) return null;

  return user?.is_invited
    ? "/onboarding/project-setup"
    : "/onboarding/get-started";
}
